/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class SalesListViewModel extends JSONable {
  uuid: string | undefined = undefined;
  pid: string | undefined = undefined;
  name: string | undefined = undefined;
  department: string | undefined = undefined;
  email: string | undefined = undefined;
  phoneNumber: string | undefined = undefined;
  territories: string | undefined = undefined;
  assignedFrom: string | undefined = undefined;
  validFrom: string | undefined = undefined;
  validTo: string | undefined = undefined;
  manager: string | undefined = undefined;
  latestOpportunity: string | undefined = undefined;
  LatestActivity: string | undefined = undefined;
  salesChannelValue: string | undefined = undefined;
}
